"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserQuizServiceClient = void 0;
var UserQuizServiceClient_1 = require("./UserQuizServiceClient");
Object.defineProperty(exports, "UserQuizServiceClient", { enumerable: true, get: function () { return __importDefault(UserQuizServiceClient_1).default; } });
//# sourceMappingURL=index.js.map